import React from "react";
import Header from "@/components/header";
import Footer from "@/components/footer";
import dynamic from "next/dynamic";

// Import CallToAction dynamically with SSR disabled to avoid framer-motion issues
const CallToAction = dynamic(() => import("@/components/call-to-action"), {
  ssr: false,
  loading: () => <div className="h-32 bg-gray-100 animate-pulse rounded"></div>
});

// Import PlateSearch dynamically with SSR disabled to avoid geocoding issues
const PlateSearch = dynamic(() => import("@/components/plate-search"), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-100 animate-pulse rounded"></div>
});
import Head from "next/head";
import Link from "next/link";

import { motion } from "framer-motion";
import { titleInitial, titleAnimate } from "@/components/animations";
import MapBackground from "@/components/map-background";
import { Button } from "@/components/ui/button";


export default function NumberPlateSearch() {
  return (
    <>
      <Head>
        <title>Partbot - Australian Number Plate Search</title>
      </Head>
      <Header />
      <main>
        <MapBackground />
        <div className="relative pt-24 md:py-8">
          <div className="container mx-auto overflow-x-hidden md:overflow-x-visible lg:col-start-2 lg:pt-16">
            <div className="mt-6 grid grid-cols-1 gap-12 md:mt-0 md:pt-24 lg:grid-cols-2">
              <div className="space-y-4 px-6 md:pb-0">
                <motion.h1
                  initial={titleInitial}
                  whileInView={titleAnimate()}
                  viewport={{ once: true }}
                  className="text-balance bg-gradient-to-r from-stone-100 via-white to-stone-100 bg-clip-text pb-5 pr-8 text-4xl font-extrabold leading-none tracking-tight text-transparent drop-shadow-lg md:from-stone-100 md:via-white md:to-stone-100 lg:text-6xl"
                >
                  Search by Number Plate
                </motion.h1>

                <motion.div
                  initial={titleInitial}
                  whileInView={titleAnimate(0.25)}
                  viewport={{ once: true }}
                  className="prose text-balance text-emerald-300/75"
                >
                  <p className="text-lg">
                    Add an Australian vehicle registration search to your auto
                    parts ecommerce store. Help your customers find the part
                    that fits their vehicle through the easiest search method
                    available.
                  </p>
                </motion.div>
                <motion.div
                  initial={titleInitial}
                  whileInView={titleAnimate(0.5)}
                  viewport={{ once: true }}
                  className="hidden items-center space-x-6 pt-6 md:flex"
                >
                  <Button asChild className="bg-emerald-500">
                    <Link href="/pricing">View Pricing</Link>
                  </Button>
                  <p className="text-xs leading-none text-stone-300 lg:text-sm">
                    Available via API or plugin.
                  </p>
                </motion.div>
              </div>
              <motion.div
                initial={titleInitial}
                whileInView={titleAnimate(0.75, 1.5)}
                viewport={{ once: true }}
                className="mt-2 flex items-start justify-end px-3 md:-mt-12"
              >
                <div className="relative w-full max-w-2xl">
                  <div className="pointer-events-none absolute -right-2 -top-12 z-20 size-20 md:-right-5 md:-top-14 md:size-24">
                    <span className="absolute inset-0 h-full w-full animate-ping rounded-full bg-amber-400 opacity-10"></span>
                    <div className="absolute inset-0 z-10 flex aspect-square size-20 rotate-12 transform items-center justify-center rounded-full bg-amber-500 md:size-24">
                      <span className="text-center text-lg font-extrabold leading-none text-primary-foreground md:text-xl">
                        Try me!
                      </span>
                    </div>
                  </div>
                  <PlateSearch displayMode="inline" demoMode={true} />
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Brands section */}
        {/* <Brands /> */}

        {/* CTA Section */}
        <CallToAction />
      </main>
      <Footer />
    </>
  );
}
